import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_reservation_hdr_RowClass } from '../../../dbschema/bl_inv_stock_reservation_hdr.model';

export class StockReservationModel extends BaseContainerModel {
  bl_inv_stock_reservation_hdr: Bl_inv_stock_reservation_hdr_RowClass = new Bl_inv_stock_reservation_hdr_RowClass();
}
